/* eslint-disable no-console */
import { MarkdownCell } from "@jupyterlab/cells";
import { Notebook } from "@jupyterlab/notebook";
import { markdownToolbarJupyterLab } from "../../../connector/extensions/markdownToolbarJupyterLab";
import { Unsubscribe } from "../../../types/Unsubscribe";
import { afterCalled } from "./afterCalled";
import { getJupyterLab } from "./getJupyterLab";

/** List of events to unsubscribe when content changes. */
const unsubscribes: Unsubscribe[] = [];

/**
 * Iterates and registers toolbars on all markdown cells.
 * Automatically handles disposal of prior executions (idempotent).
 */
export const registerMarkdownToolbars = async () => {
  const jl = await getJupyterLab();

  // Unsubscribe all events first.
  while (unsubscribes.length) {
    const unsubscribe = unsubscribes.pop();
    if (unsubscribe) {
      unsubscribe();
    }
  }

  const nb = jl.notebookTracker.currentWidget?.content;
  if (!nb) {
    console.warn("Notebook content DNE, could not apply markdown headings.");
    return;
  }

  // Resubscribe to events for the new set of cells.
  nb.widgets
    .filter(widget => widget.model.type === "markdown")
    .map(cell => cell as MarkdownCell)
    .forEach(cell => {
      unsubscribes.push(
        afterCalled(cell.editorWidget, "onAfterShow", () => {
          console.log("onAfterShow", cell);
          markdownToolbarJupyterLab.handleEditCell(cell);
        })
      );
    });

  // If a new cell gets activated, the old cell needs to get rendered.
  const handleActiveCellChanged = (slot: Notebook) => {
    if (slot.activeCell) {
      markdownToolbarJupyterLab.handleCellActive(slot.activeCell);
    }
  };

  nb.activeCellChanged.connect(handleActiveCellChanged);

  // Ensure no leaks occur if this method is called again.
  unsubscribes.push(() => {
    nb.activeCellChanged.disconnect(handleActiveCellChanged);
  });
};
